import React from "react";
import { Form, useFormikContext } from "formik";
import { CustomFormAlert } from "ui-components";
import { useTranslation } from "react-i18next";

export const CustomForm = ({
  children,
  ...props
}: React.FormHTMLAttributes<HTMLFormElement>) => {
  const { errors, isSubmitting, submitCount } = useFormikContext();
  const [t] = useTranslation("form");
  return (
    <Form {...props}>
      <CustomFormAlert
        errors={errors}
        isSubmitting={isSubmitting}
        submitCount={submitCount}
        message={t("form-error")}
      />
      {children}
    </Form>
  );
};
